document.addEventListener('DOMContentLoaded', function() {
  initCartBar();
});

document.addEventListener('shopify:section:load', function() {
  initCartBar();
});

function initCartBar() {
  const cartBar = document.querySelector('.cart-bar');
  const productFormWrapper = document.querySelector('.product__form__wrapper');
  
  if (!cartBar || !productFormWrapper) return;
  
  // Initially hide the cart bar
  cartBar.classList.add('cart-bar--hidden');
  
  // Track scroll direction
  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let scrollDirection = 'down'; // default direction
  
  // Create an Intersection Observer to monitor the product form
  const options = {
    root: null, // viewport
    rootMargin: '0px',
    threshold: [0, 0.1, 0.5]
  };
  
  let hasEnteredView = false;
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // If product form is visible at all, hide cart bar
      if (entry.isIntersecting) {
        cartBar.classList.add('cart-bar--hidden');
        hasEnteredView = true;
      } 
      // Only show cart bar if form is completely out of view AND 
      // has been seen before AND we're scrolling down (not up past it)
      else if ((hasEnteredView || isPageLoadedBelowForm()) && scrollDirection === 'down') {
        cartBar.classList.remove('cart-bar--hidden');
      } else {
        // Hide the bar when scrolling up past the form
        cartBar.classList.add('cart-bar--hidden');
      }
    });
  }, options);
  
  // Function to check if page was loaded below the product form
  function isPageLoadedBelowForm() {
    const formRect = productFormWrapper.getBoundingClientRect();
    // If the form is completely above the viewport on initial load
    return formRect.bottom < 0;
  }
  
  // Monitor scroll direction
  window.addEventListener('scroll', function() {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    
    if (st > lastScrollTop) {
      scrollDirection = 'down';
    } else {
      scrollDirection = 'up';
      
      // When scrolling up and the form is below the viewport, hide the cart bar
      const formRect = productFormWrapper.getBoundingClientRect();
      if (formRect.top > window.innerHeight) {
        cartBar.classList.add('cart-bar--hidden');
      }
    }
    
    lastScrollTop = st <= 0 ? 0 : st; // For mobile or negative scrolling
  }, false);
  
  // Check initial position right away
  if (isPageLoadedBelowForm()) {
    cartBar.classList.remove('cart-bar--hidden');
    hasEnteredView = true; // Mark as having entered view to maintain proper state
  }
  
  // Start observing the product form
  observer.observe(productFormWrapper);
  
  // Connect cart bar button to scroll to product form
  const addToCartBtn = cartBar.querySelector('a.btn');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      // Scroll to the form with smooth behavior
      productFormWrapper.scrollIntoView({behavior: 'smooth'});
    });
  }
}